import { colors, transitions } from "assets/style/Variable";
import styled from "styled-components";

interface LineCheckboxType {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

export default function LineCheckbox({
  id,
  label,
  checked,
  onChange,
  className,
}: LineCheckboxType) {
  return (
    <StyleLineCheckbox className={className}>
      <label htmlFor={id} className="checkbox-label">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="checkbox-ui" aria-hidden="true" />
        <span className="label-text">{label}</span>
      </label>
    </StyleLineCheckbox>
  );
}

const StyleLineCheckbox = styled.div`
  display:inline-flex;
  align-items:center;
  .checkbox-label {
    display:inline-flex;
    align-items:center;
    gap:8px;
    min-height:32px;
    padding:0 10px 0 0;
    cursor:pointer;
    user-select:none;
  }
  input {
    position:absolute;
    width:1px;
    height:1px;
    margin:-1px;
    overflow:hidden;
    clip:rect(0, 0, 0, 0);
    border:0;
  }
  .checkbox-ui {
    display:inline-flex;
    flex-shrink:0;
    position:relative;
    width:20px;
    height:20px;
    border:1px solid ${colors.lineColor};
    border-radius:999px;
    background:${({ theme }) => theme.bgOrigin};
    transition:${transitions.base};
    box-shadow:inset 0 0 0 1px rgba(255,255,255,.08);
    &::after {
      position:absolute;
      top:4px;
      left:6px;
      width:5px;
      height:9px;
      border-right:2px solid ${({ theme }) => theme.color};
      border-bottom:2px solid ${({ theme }) => theme.color};
      opacity:0;
      transform:rotate(45deg) scale(.6);
      transform-origin:center;
      transition:${transitions.base};
      content:'';
    }
    &::before {
      position:absolute;
      inset:3px;
      border-radius:999px;
      background:${({ theme }) => theme.opacityBg};
      content:'';
    }
  }
  .label-text {
    font-size:13px;
    line-height:1;
    color:${({ theme }) => theme.color};
    white-space:nowrap;
  }
  input:checked + .checkbox-ui {
    border-color:${colors.lineColor};
    background:${({ theme }) => theme.bgOrigin};
    &::after {
      opacity:1;
      transform:rotate(45deg) scale(1);
    }
  }
  input:focus-visible + .checkbox-ui {
    outline:2px solid rgba(106, 103, 229, .2);
    outline-offset:2px;
  }
`;
